import React from "react";

function SakalaServices() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">
          KSRTC SERVICES UNDER SAKALA:
        </h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            User Manual for Designated Offices for Service Management:
          </h5>
          <span>Click Here</span>
        </div>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            For Citizen to View the SAKALA Services Details:
          </h5>
          <span>Click Here</span>
        </div>
      </div>
    </div>
  );
}

export default SakalaServices;
